import { TRootState } from "@/store/app/store";

export const tabsListSelector = (state: TRootState) => state.tabs.list;
export const activeTabSelector = (state: TRootState) => state.tabs.activeTab;
export const isBrokerSelector = (state: TRootState) => state.tabs.isBroker;
